/* eslint-disable */
document.addEventListener("alpine:init", () => {
  Alpine.data("accordions", (config) => ({
    uuid: config.uuid,
    displayAll: false,
    autoCollapse: config.autoCollapse,
    initialOpenState: config.initialOpenState,
    showMax: config.showMax,
    init() {
      if (this.autoCollapse && this.initialOpenState) {
        if (this.$isEditMode()) {
          return;
        }

        const _self = this;
        setTimeout(function () {
          _self.$dispatch("accordions-toggle", { action: false, targetID: "accordions-" + _self.uuid });
        }, 15000);
      }
    },      
    showItem(index) {
      return this.showMax >= index || this.displayAll;
    },
    toggleAll(action, uuid) {
      this.$dispatch('accordions-toggle', { action, targetID: 'accordions-' + uuid })
    }
  }));
});
